angular.module('cvsApp').factory('WCMContent', function() {

   var contentManaged={};
   var content={};

    contentManaged.setContent=function(contentName,contentValue){
        content[contentName]=contentValue;
    };

    contentManaged.getContent=function(){
        return content;
    };

return contentManaged;
});
